import { Injectable, inject } from '@angular/core';
import { ApiService } from '@targx/index';
import { Observable } from 'rxjs';
import { ViewPreferenceDto, ViewPreferenceState } from './view-preferences.types';

@Injectable({ providedIn: 'root' })
export class ViewPreferencesService {
    private readonly _api = inject(ApiService);

    findAll$(): Observable<ViewPreferenceDto[]> {
        return this._api.get<ViewPreferenceDto[]>('/v1/view-preferences');
    }

    update$(key: string, state: ViewPreferenceState): Observable<unknown> {
        return this._api.put(`/v1/view-preferences/${key}`, { state });
    }
}
